<div *ngIf="isMergingData" class="merge-banner">
  <mat-icon class="merge-spin-icon">sync</mat-icon>
  <mat-progress-bar
    mode="indeterminate"
    color="accent"
    class="merge-progress"
  ></mat-progress-bar>
  <span class="merge-message">Cargando itinerarios principales...</span>
</div>

<ng-container *ngIf="isLoading; else tableBlock">
  <div class="skeleton-wrapper">
    <div class="loading-summary">
      <div class="loading-icon-shell">
        <mat-icon>table_view</mat-icon>
      </div>
      <div class="loading-copy">
        <span class="loading-eyebrow">Un momento</span>
        <h3>Preparando tabla de programación</h3>
        <p>
          Estamos cargando, ordenando y preparando los files para mostrar la
          información actualizada.
        </p>
      </div>
      <span class="loading-status-pill">{{ loadingMessage }}</span>
    </div>

    <mat-progress-bar
      mode="indeterminate"
      color="accent"
      class="loading-progress"
    ></mat-progress-bar>

    <div class="skeleton-table">
      <div class="sk-row sk-header-row">
        <div class="sk-cell sk-file">
          <div class="sk-line shimmer sk-w-50"></div>
        </div>
        <div class="sk-cell sk-medium">
          <div class="sk-line shimmer sk-w-55"></div>
        </div>
        <div class="sk-cell sk-medium">
          <div class="sk-line shimmer sk-w-80"></div>
        </div>
        <div class="sk-cell sk-center">
          <div class="sk-line shimmer sk-w-50"></div>
        </div>
        <div class="sk-cell sk-date">
          <div class="sk-line shimmer sk-w-80"></div>
        </div>
        <div class="sk-cell sk-review">
          <div class="sk-line shimmer sk-w-110"></div>
        </div>
        <div class="sk-cell sk-actions">
          <div class="sk-line shimmer sk-w-55"></div>
        </div>
      </div>
      <ng-container *ngFor="let _ of skeletonRows">
        <div class="sk-row sk-data-row">
          <div class="sk-cell sk-file sk-column">
            <div class="sk-line shimmer sk-w-75"></div>
            <div class="sk-line shimmer sk-w-45"></div>
          </div>
          <div class="sk-cell sk-medium">
            <div class="sk-line shimmer sk-w-70"></div>
          </div>
          <div class="sk-cell sk-medium">
            <div class="sk-line shimmer sk-pill"></div>
          </div>
          <div class="sk-cell sk-center">
            <div class="sk-circle shimmer"></div>
          </div>
          <div class="sk-cell sk-date sk-column">
            <div class="sk-line shimmer sk-w-75"></div>
            <div class="sk-line shimmer sk-w-50"></div>
          </div>
          <div class="sk-cell sk-review">
            <div class="sk-circle shimmer"></div>
          </div>
          <div class="sk-cell sk-actions">
            <div class="sk-circle shimmer"></div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>

<ng-template #tableBlock>
  <div class="filtering-indicator" *ngIf="isFiltering">
    <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
    <span>Actualizando resultados...</span>
  </div>

  <div class="table-toolbar">
    <div class="table-toolbar-info">
      <span class="record-count">
        <mat-icon class="count-icon">table_rows</mat-icon>
        {{ visibleCount }} file{{ visibleCount !== 1 ? "s" : "" }} encontrado{{
          visibleCount !== 1 ? "s" : ""
        }}
      </span>
      <span class="table-mode-help">
        Usa el paginador al final de la tabla para avanzar entre resultados.
      </span>
    </div>
  </div>

  <div class="table-surface">
    <div class="table-wrapper">
      <mat-table
        [dataSource]="dataSource"
        [trackBy]="trackById"
        matSort
        [matSortActive]="sortActive"
        [matSortDirection]="sortDirection"
        matSortDisableClear
        (matSortChange)="sortChange.emit($event)"
        class="row-review"
      >
        <ng-container matColumnDef="file" sticky>
          <mat-header-cell *matHeaderCellDef class="monoHeader column-file"
            >File</mat-header-cell
          >
          <mat-cell *matCellDef="let row" class="monoHeader column-file">
            <div class="file-info">
              <button
                type="button"
                class="file-name"
                [matTooltip]="row.nombreItinerario || 'Sin itinerario'"
                (click)="openFile.emit(row)"
              >
                {{ row.nombreItinerario }}
              </button>
              <span class="file-number"
                >{{ row.fileNumber }}{{ row.fileExtend }}</span
              >
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="agency">
          <mat-header-cell *matHeaderCellDef class="monoHeader column-agencia"
            >Cliente</mat-header-cell
          >
          <mat-cell
            *matCellDef="let row"
            class="monoHeader column-agencia"
            [matTooltip]="row.nameClient || 'Sin cliente'"
            >{{ row.nameClient }}</mat-cell
          >
        </ng-container>

        <ng-container matColumnDef="seller">
          <mat-header-cell *matHeaderCellDef class="monoHeader column-ds"
            >Responsable</mat-header-cell
          >
          <mat-cell
            *matCellDef="let row"
            class="monoHeader column-ds"
            [matTooltip]="row.usuario || 'Sin responsable'"
            >{{ row.usuario }}</mat-cell
          >
        </ng-container>

        <ng-container matColumnDef="displayState">
          <mat-header-cell *matHeaderCellDef class="dobleHeader column-estado">
            Estado
          </mat-header-cell>
          <mat-cell *matCellDef="let file" class="dobleHeader column-estado">
            <div
              class="estado-pill"
              [ngClass]="file._pillClass"
              [matTooltip]="getStateActionTooltip(file)"
              (click)="changeFileState.emit(file)"
            >
              <span>{{ file?.displayState | titlecase }}</span>
              <span class="state-action-shell">
                <i-tabler
                  [name]="getStateActionIcon(file)"
                  class="pill-pencil-icon"
                ></i-tabler>
              </span>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="guide">
          <mat-header-cell *matHeaderCellDef>Guía</mat-header-cell>
          <mat-cell *matCellDef="let row">
            <ng-container *ngIf="getMainGuideName(row); else noGuide">
              <button
                mat-icon-button
                matTooltip="GUÍA: {{ getMainGuideName(row) }}"
                matTooltipPosition="right"
                class="guide-button assigned"
              >
                <span class="table-icon-shell tone-guide-assigned">
                  <i-tabler name="user" class="icon-tabler-user"></i-tabler>
                </span>
              </button>
            </ng-container>
            <ng-template #noGuide>
              <button
                mat-icon-button
                matTooltip="Sin guía principal"
                matTooltipPosition="right"
                class="guide-button empty"
              >
                <span class="table-icon-shell tone-guide-empty">
                  <i-tabler name="user" class="icon-tabler-user"></i-tabler>
                </span>
              </button>
            </ng-template>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="paxQuantity">
          <mat-header-cell *matHeaderCellDef>Pasajeros</mat-header-cell>
          <mat-cell *matCellDef="let row">
            <button
              mat-icon-button
              (click)="openPassengers.emit(row)"
              matTooltip="Ver pasajeros"
            >
              <span
                class="table-icon-shell metric-button"
                [ngClass]="row._paxAssigned ? 'tone-success' : 'tone-warning'"
                [matBadge]="row._paxCountDisplay"
                [matTooltip]="
                  row._paxAssigned
                    ? 'Pasajeros asignados'
                    : 'Pasajeros NO asignados'
                "
                matTooltipPosition="right"
              >
                <i-tabler name="users" class="icon-tabler-users"></i-tabler>
              </span>
            </button>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="tcQuantity">
          <mat-header-cell *matHeaderCellDef>TC</mat-header-cell>
          <mat-cell *matCellDef="let row">
            <button
              mat-icon-button
              (click)="openPassengers.emit(row)"
              matTooltip="Ver tour conductors"
            >
              <span
                class="table-icon-shell metric-button"
                [ngClass]="
                  row._tcCountDisplay > 0 ? 'tone-success' : 'tone-warning'
                "
                [matBadge]="row._tcCountDisplay"
                [matTooltip]="
                  row._tcCountDisplay > 0
                    ? 'TC registrados'
                    : 'Sin TC registrados'
                "
                matTooltipPosition="right"
              >
                <i-tabler name="user-star" class="icon-tabler-users"></i-tabler>
              </span>
            </button>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="flights">
          <mat-header-cell *matHeaderCellDef>Vuelos</mat-header-cell>
          <mat-cell *matCellDef="let row">
            <button mat-icon-button (click)="openFlights.emit(row.id)">
              <span
                class="table-icon-shell"
                [ngClass]="
                  row._vuelosAssigned ? 'tone-success' : 'tone-warning'
                "
                [matTooltip]="
                  row._vuelosAssigned
                    ? 'Vuelos asignados'
                    : row._hasPartialFlights
                      ? 'Vuelos parcialmente asignados'
                      : 'Sin vuelos asignados'
                "
                matTooltipPosition="right"
              >
                <i-tabler name="plane" class="plane-icon"></i-tabler>
              </span>
            </button>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="operationDate">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header="startDateFile"
            class="column-date"
            >F. Operación</mat-header-cell
          >
          <mat-cell *matCellDef="let row" class="column-date text-muted">{{
            row.fechaOperacion | customDate | date: "dd/MM/yyyy"
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="createdAt">
          <mat-header-cell *matHeaderCellDef class="column-date"
            >F. Creación</mat-header-cell
          >
          <mat-cell *matCellDef="let row" class="column-date text-muted">{{
            row.createdAt | date: "dd/MM/yyyy"
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="updatedAt">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header="updatedAt"
            class="column-date"
            >F. Act</mat-header-cell
          >
          <mat-cell *matCellDef="let row" class="column-date">
            <div class="updated-at">
              <span>{{ row._updatedAtDate }}</span>
              <span>{{ row._updatedAtTime }}</span>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="programmingReview">
          <mat-header-cell *matHeaderCellDef>Rev. Programación</mat-header-cell>
          <mat-cell *matCellDef="let row">
            <ng-container
              *ngIf="
                row.pendingPreOpIncidents != null;
                else withoutPreOpIncident
              "
            >
              <div
                class="review-icon-container"
                (click)="openPreOperationalIncidents.emit(row)"
              >
                <ng-container
                  *ngIf="row.pendingPreOpIncidents === 0; else hasPending"
                >
                  <span
                    class="table-icon-shell tone-success"
                    matTooltip="Sin incidentes pendientes"
                    matTooltipPosition="above"
                  >
                    <i-tabler
                      name="message-report"
                      class="icon-tabler-review icon-check"
                    ></i-tabler>
                  </span>
                </ng-container>
                <ng-template #hasPending>
                  <span
                    class="table-icon-shell tone-danger"
                    [matBadge]="row.pendingPreOpIncidents"
                    matTooltip="Incidentes pendientes"
                    matTooltipPosition="above"
                  >
                    <i-tabler
                      name="message-report"
                      class="icon-tabler-review icon-resolved"
                    ></i-tabler>
                  </span>
                </ng-template>
              </div>
            </ng-container>
            <ng-template #withoutPreOpIncident>
              <button
                mat-icon-button
                (click)="openPreOperationalIncidents.emit(row)"
              >
                <span
                  class="table-icon-shell tone-empty"
                  matTooltip="Sin revisión de programación"
                  matTooltipPosition="above"
                >
                  <i-tabler
                    name="message-report"
                    class="icon-tabler-review icon-gray"
                  ></i-tabler>
                </span>
              </button>
            </ng-template>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="bibleReview">
          <mat-header-cell *matHeaderCellDef>Rev. Biblia</mat-header-cell>
          <mat-cell *matCellDef="let row">
            <ng-container
              *ngIf="row.pendingCsReviews != null; else withoutCsReview"
            >
              <div
                class="review-icon-container"
                (click)="openCsReview.emit(row)"
              >
                <ng-container
                  *ngIf="row.pendingCsReviews === 0; else hasCsPending"
                >
                  <span
                    class="table-icon-shell tone-success"
                    matTooltip="Sin revisiones pendientes"
                    matTooltipPosition="above"
                  >
                    <i-tabler
                      name="book"
                      class="icon-tabler-review icon-check"
                    ></i-tabler>
                  </span>
                </ng-container>
                <ng-template #hasCsPending>
                  <span
                    class="table-icon-shell tone-danger"
                    [matBadge]="row.pendingCsReviews"
                    matTooltip="Revisiones AC pendientes"
                    matTooltipPosition="above"
                  >
                    <i-tabler
                      name="book"
                      class="icon-tabler-review icon-resolved"
                    ></i-tabler>
                  </span>
                </ng-template>
              </div>
            </ng-container>
            <ng-template #withoutCsReview>
              <button mat-icon-button (click)="openCsReview.emit(row)">
                <span
                  class="table-icon-shell tone-empty"
                  matTooltip="Sin revisión de biblia"
                  matTooltipPosition="above"
                >
                  <i-tabler
                    name="book"
                    class="icon-tabler-review icon-gray"
                  ></i-tabler>
                </span>
              </button>
            </ng-template>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions" stickyEnd>
          <mat-header-cell *matHeaderCellDef>Acciones</mat-header-cell>
          <mat-cell *matCellDef="let row">
            <button
              mat-icon-button
              class="btn-action-view"
              matTooltip="Abrir file"
              matTooltipPosition="left"
              (click)="openFile.emit(row)"
            >
              <i-tabler name="eye"></i-tabler>
            </button>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: displayedColumns"
          [class]="row._rowBgColor"
        ></mat-row>
      </mat-table>
    </div>
    <div class="paginator-shell">
      <mat-paginator
        [length]="paginatorLength"
        [pageIndex]="pageIndex"
        [pageSize]="pageSize"
        [pageSizeOptions]="[10, 25, 50]"
        (page)="pageChange.emit($event)"
      ></mat-paginator>
    </div>
  </div>

  <div *ngIf="visibleCount === 0" class="empty-state">
    <mat-icon class="empty-icon">folder_open</mat-icon>
    <h3>No se encontraron files</h3>
    <p>Intenta ajustar los filtros o actualiza la lista</p>
    <button
      mat-stroked-button
      class="btn-empty-refresh"
      (click)="refresh.emit()"
    >
      <mat-icon>refresh</mat-icon>
      Actualizar lista
    </button>
  </div>
</ng-template>
